import {AttributeTypeEnum} from "../../../enums/AttributeTypeEnum";
import Utils from "../../../../../Utils";
import _ from "lodash";
import * as toastr from "toastr";

export default function getManageDataEditor() {
    let value = '';
    let defaultValue = '';
    let isDefault = false;

    function AgManageDataAttributes() {
    }

    AgManageDataAttributes.prototype.init = function (params) {
        isDefault = false;
        this.params = params;
        AgManageDataAttributes.prototype.cellEditorparams = params.data.cellEditorParams || {};
        switch (params.colDef.dataType) {
            case AttributeTypeEnum.EMAIL:
                this.eInput = document.createElement('input');
                break;
            case AttributeTypeEnum.VALUE_LIST:
                this.eInput = document.createElement('select');
                this.eInput.multiple = true;
                this.eInput.id = 'grid-drop-down';
                this.eInput.style.width = "100%";
                value = params.data.value;
                let attributeValues = _.cloneDeep(params.column.userProvidedColDef.attrVals);
                if (attributeValues && attributeValues.length > 0) {
                    attributeValues.sort(function(a, b){
                        if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                        if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                        return 0;
                    });
                }
                attributeValues.forEach(attribute => {
                    let option;
                    let dataValue = params.value ? params.value : params.data.value
                    if (dataValue.length === 1 && dataValue[0] === 'n/a') {
                        if (attribute.name !== 'n/a') {
                            option = new Option(attribute.name, attribute.name);
                        }
                    } else {
                        option = new Option(attribute.name, attribute.name);
                    }
                    Utils.$(this.eInput).append(option)
                });
                break;
            case AttributeTypeEnum.TEXT:
            case AttributeTypeEnum.JSON:
                this.eInput = document.createElement('textarea') as HTMLTextAreaElement;
                this.eInput.style.color = "#EEEEEE";
                this.eInput.style.width = "100%"
                this.eInput.style.background = "#262C2E"
                this.eInput.rows = AgManageDataAttributes.prototype.cellEditorparams.rows || 6;
                this.eInput.cols = AgManageDataAttributes.prototype.cellEditorparams.cols || 20;
                this.eInput.maxLength = AgManageDataAttributes.prototype.cellEditorparams.maxLength || 1000;
                value = params.value;
                defaultValue = params.data.defaultValue.toString();
                if (params.value.toString() !== params.data.defaultValue.toString()) {
                    this.eInput.value = params.value;
                } else {
                    isDefault = true;
                }
                const mismatchAttr = Utils.getInferenceMismatchDefinition(params, true);
                if (mismatchAttr) {
                    toastr.warning(mismatchAttr.informativeMessage);
                }
                break;
            case AttributeTypeEnum.INCREMENTING:
                this.eInput = document.createElement('input');
                this.eInput.type = "text";
                this.eInput.style.width = "100%";
                this.eInput.value = params.value;
                break;
            case AttributeTypeEnum.INT:
                this.eInput = document.createElement('input');
                this.eInput.type = "number";
                this.eInput.style.width = "100%";
                value = params.value;
                defaultValue = params.data.defaultValue.toString();;
                if (params.value.toString() !== params.data.defaultValue.toString()) {
                    this.eInput.value = params.value;
                } else {
                    isDefault = true;
                }
                break;
            case AttributeTypeEnum.DECIMAL:
                this.eInput = document.createElement('input');
                this.eInput.type = "number";
                this.eInput.step = ".01";
                this.eInput.style.width = "100%";
                value = params.value;
                defaultValue = params.data.defaultValue.toString();;
                if (params.value.toString() !== params.data.defaultValue.toString()) {
                    this.eInput.value = params.value;
                } else {
                    isDefault = true;
                }
                break;
            case AttributeTypeEnum.DATE:
                this.eInput = document.createElement('input');
                this.eInput.type = "text";
                this.eInput.style.width = "100%";
                this.eInput.value = params.value;
                Utils.$(this.eInput).datepicker({
                    dateFormat: 'yy-mm-dd',
                    showButtonPanel: true,
                    beforeShow: function () {
                        setTimeout(function () {
                            Utils.$('.ui-datepicker').css('z-index', 50);
                        }, 0);
                    },
                    onSelect: function() {
                        Utils.$(this).data('datepicker').inline = true;
                    },
                    onClose: function() {
                        Utils.$(this).data('datepicker').inline = false;
                    }
                });
                break;
            case AttributeTypeEnum.TIMESTAMP:
                this.eInput = document.createElement('input');
                this.eInput.type = "text";
                this.eInput.style.width = "100%";
                this.eInput.value = params.value;
                Utils.$(this.eInput).datetimepicker({
                    format: 'Y-m-d\\TH:i:s',
                    validateOnBlur: false,
                });
                break;
            case AttributeTypeEnum.TIME:
                this.eInput = document.createElement('input');
                this.eInput.style.width = "100%";
                this.eInput.value = params.value;
                Utils.$(this.eInput).datetimepicker({
                    format: 'H:i:s',
                    datepicker: false
                });
                break;
            case AttributeTypeEnum.LOOKUP:
                this.eInput = document.createElement('input');
                this.eInput.value = params.value;
                break;
            default:
                this.eInput = document.createElement('input');
                this.eInput.style.width = "100%";
                this.eInput.value = params.value;
        }
    };

    AgManageDataAttributes.prototype.isKeyPressedNavigation = function (event) {
        return event.keyCode === 39 || event.keyCode === 37;
    };

    AgManageDataAttributes.prototype.getGui = function () {
        return this.eInput;
    };

    AgManageDataAttributes.prototype.afterGuiAttached = function () {
        switch (this.params.colDef.dataType) {
            case AttributeTypeEnum.EMAIL:
                let attributeValues = _.cloneDeep(this.params.column.userProvidedColDef.attrVals);
                let options = attributeValues.map(item => item.name);
                Utils.$(this.eInput).select2({
                    width: '100%',
                    multiple: true,
                    tags: options
                });
                let parsedVal;
                try {
                    parsedVal = JSON.parse(this.params.value)
                } catch(e) {
                    if (typeof this.params.value === 'string') {
                        parsedVal = [ this.params.value ];
                    } else {
                        parsedVal = this.params.value;
                    }
                }
                Utils.$(this.eInput).select2("val", parsedVal);
                Utils.$(this.eInput).select2('open');
                this.eInput.focus();
                Utils.$('.select2-results').addClass('select2-results-custom select2-highlighted-custom select2-no-results-custom');
                Utils.$('#select2-drop').addClass('select2-drop-custom select2-drop-active-custom');
                break;
            case AttributeTypeEnum.VALUE_LIST:
                Utils.$(this.eInput).select2().val(this.params.value).trigger("change");
                Utils.$(this.eInput).select2({width: 200});

                this.eInput.focus();
                Utils.$(this.eInput).select2('open');
                Utils.$('.select2-results').addClass('select2-results-custom select2-highlighted-custom select2-no-results-custom');
                Utils.$('#select2-drop').addClass('select2-drop-custom select2-drop-active-custom');
                break;
            default:
                this.eInput.focus();
        }
    };

    AgManageDataAttributes.prototype.isCancelBeforeStart = function () {
        return false
    };

    AgManageDataAttributes.prototype.isCancelAfterEnd = function () {
        return false
    };

    AgManageDataAttributes.prototype.getValue = function () {
        switch (this.params.colDef.dataType) {
            case AttributeTypeEnum.LOOKUP:
                if (this.params.value) {
                    return this.params.value;
                } else {
                    return this.params.data.value;
                }
            case AttributeTypeEnum.VALUE_LIST:
                const val = Utils.$(this.eInput).val();
                if (val.length === 0) {
                    return ['n/a'];
                } else {
                    return Utils.$(this.eInput).val();
                }
            case AttributeTypeEnum.INT:
            case AttributeTypeEnum.DECIMAL:
                if (Utils.$(this.eInput).val() === '') {
                    if (isDefault) {
                        return value;
                    } else {
                        return '-1';
                    }
                } else {
                    return Utils.$(this.eInput).val();
                }
            case AttributeTypeEnum.JSON:
                if (Utils.$(this.eInput).val() === '') {
                    if (isDefault) {
                        return value;
                    } else {
                        return '{}';
                    }
                } else {
                    return Utils.$(this.eInput).val();
                }
            case AttributeTypeEnum.EMAIL:
                return Utils.$(this.eInput).val();
            default:
                if (Utils.$(this.eInput).val() === '') {
                    if (isDefault) {
                        return value;
                    } else {
                        return 'n/a';
                    }
                } else {
                    return Utils.$(this.eInput).val();
                }
        }
    };

    AgManageDataAttributes.prototype.destroy = function () {
    };

    AgManageDataAttributes.prototype.isPopup = function () {
        try {
            return this.params.colDef.cellEditorParams?.isPopup
        } catch (e) {
            return false;
        }
    };

    return AgManageDataAttributes
}



// WEBPACK FOOTER //
// ./app/components/bo-core/grids/ManageDataGrid/components/ManageDataSelector.tsx